import { useCallback } from "react";

import { Row, Col, Label, FormGroup, FormSection, Button } from "twyne-new.ui";

import Fields from "./Fields";
import Menu from "./Menu";
import { ACTION, PARSE } from "./utils";

export default function Tool({ definitions, value = {}, onChange }) {
  const handleAction = useCallback(({ action, ...props }) => {
    let data = value
    if (action === ACTION.CHANGE) {
      data = PARSE.change({ data, ...props })
    }
    if (action === ACTION.ADD_ALL) {
      data = PARSE.addAll({ data, ...props })
    }
    if (action === ACTION.REMOVE_ALL) {
      data = PARSE.removeAll({ data, ...props })
    }
    if (action === ACTION.ADD) {
      data = PARSE.add({ data, ...props })
    }
    if (action === ACTION.REMOVE) {
      data = PARSE.remove({ data, ...props })
    }
    onChange({ ...data })
  }, [value, onChange])

  return <Row className='relative'>
    <div className='absolute top-0 right-0'>
      <Menu definitions={definitions} data={value} onAction={handleAction} />
    </div>
    <Col size="12">
      <Form definitions={definitions} data={value} onAction={handleAction} />
    </Col>
  </Row>
}

function Form({ definitions, data, onAction }) {
  return <Row>
    <Col size="12">
      {Object.keys(data).map(group => <Group key={group} onAction={onAction}
        group={group} definitions={definitions} groupValue={data[group]} data={data} />)}
    </Col>
  </Row>
}

function Group({ group, groupValue, data, definitions, onAction }) {
  const { label, fields } = definitions[group]

  return <>
    <FormSection>{label}</FormSection>
    <Row>
      {Object.keys(groupValue).map(field => <Field key={field} group={group} field={field}
        definitions={fields} fieldValue={groupValue[field]} data={data} onAction={onAction} />)}
    </Row>
  </>
}

function Field({ group, field, fieldValue, data, definitions, onAction }) {
  const { Component, label, size, onChange, ...props } = definitions[field]

  const handleChange = (value, options = {}) => {
    if (onChange) {
      value = onChange(value)
    }
    onAction({ action: ACTION.CHANGE, group, field, value, ...options })
  }

  if (Component) {
    return <FormField group={group} field={group} label={label} size={size} onAction={onAction}>
      <Component data={data} group={group} field={field}
        value={fieldValue} onChange={handleChange} {...props} />
    </FormField>
  }

  return <FormField group={group} field={field} label={label} size={size} onAction={onAction}>
    <Fields data={data} group={group} field={field}
      value={fieldValue} onChange={handleChange} {...props} />
  </FormField>
}

function FormField({ group, field, label, size, children, onAction }) {
  const handleRemove = useCallback(event => {
    event.stopPropagation()
    onAction({ action: ACTION.REMOVE, group, field })
  }, [group, field, onAction])

  return <Col
    size={size || "4"}
    className='group'
  >
    <FormGroup className='relative'>
      <Label>{label}</Label>
      <Button size='sm' variant='ghost' color='danger' onClick={handleRemove} className='text-sm absolute right-0 opacity-0 group-hover:opacity-100 transition-all'>
        remove
      </Button>
      {children}
    </FormGroup>
  </Col>
}
